
import { defineComponent } from "vue";
import PlanPackagePropertyJournal from "@/components/journals/PlanPackageJournal/PlanPackagePropertyJournal.vue";
import PlanPackageLengthJournal from "@/components/journals/PlanPackageJournal/PlanPackageLengthJournal.vue";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";

export default defineComponent({
  components: {
    PlanPackagePropertyJournal,
    PlanPackageLengthJournal,
  },
  emits: ["updateParent"],
  props: {
    parentModel: { required: true },
    updateParentModelCallback: { required: false },
    parentEditingConfig: { required: false, type: TableEditingConfig },
  },
  methods: {
    updateParent() {
      if (this.updateParentModelCallback) {
        this.updateParentModelCallback();
      }
    },
  },
  data() {
    return {};
  },
});
